export default "__VITE_ASSET__Be7h1buL__"